import { useState, useEffect } from 'react';
import { UserDetails } from '../types';
import FollowedUsersStorage from '../localStorage/followedUsersStorage';

/**
 * Hook for managing followed users
 */
const useFollowUser = () => {
  // Initialize the storage service
  const followedUsersStorage = new FollowedUsersStorage();
  
  // State to track followed user IDs
  const [followedUserIds, setFollowedUserIds] = useState<string[]>([]);

  // Load followed users on mount
  useEffect(() => {
    const storedIds = followedUsersStorage.getFollowedUserIds();
    setFollowedUserIds(storedIds);
  }, []);

  // Check if a user is followed
  const isFollowing = (userId?: string) => {
    if (!userId) return false;
    return followedUserIds.includes(userId);
  };

  // Follow a user
  const followUser = (user: UserDetails) => {
    followedUsersStorage.followUser(user);
    setFollowedUserIds(followedUsersStorage.getFollowedUserIds());
  };

  // Unfollow a user
  const unfollowUser = (user: UserDetails) => {
    followedUsersStorage.unfollowUser(user);
    setFollowedUserIds(followedUsersStorage.getFollowedUserIds());
  };

  // Get all followed user IDs
  const getFollowedUserIds = () => followedUserIds;

  return {
    followUser,
    unfollowUser,
    isFollowing,
    getFollowedUserIds,
  };
};

export default useFollowUser;
